<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="终端名称">
              <a-input v-model="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="终端编号">
              <a-input v-model="queryParam.code" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="所属厂区">
                <a-select
                  showSearch
                  :filterOption="filterOption"
                  v-model="queryParam.factoryId"
                  default-value="0"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in factorySelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态">
                <a-select v-model="queryParam.accreditState" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in accreditSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="终端类型">
                <a-select v-model="queryParam.type" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleAccredit(record)">授权</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="终端名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.name"
            placeholder="终端名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入终端名称'}]}]"
          />
        </a-form-item>

        <a-form-item label="终端编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="终端编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入终端编号'}]}]"
          />
        </a-form-item>

        <a-form-item label="终端类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.type"
            placeholder="请选择终端类型"
            v-decorator="['type',
            { initialValue: mdl.type, rules: [{ required: true, message: '请选择终端类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="机器码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.machineCode"
            placeholder="机器码"
            v-decorator="['machineCode',
            { initialValue: mdl.machineCode, rules: [{ required: true, message: '请输入机器码'}]}]"
          />
        </a-form-item>

        <a-form-item label="审核状态" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.accreditState"
            placeholder="审核状态"
            v-decorator="['accreditState',
            { initialValue: mdl.accreditState, rules: [{ required: true, message: '请选择审核状态'}]}]"
          >
            <a-select-option
              v-for="(item, index) in accreditSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="过期时间"
          v-if="mdl.accreditState == 2"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-date-picker
            v-model="mdl.indate"
            format="YYYY-MM-DD HH:mm:ss"
            :disabledDate="disabledDate"
            :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-item>

        <a-form-item label="所属厂区" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.factoryId"
            placeholder="所属厂区"
            v-decorator="['factoryId',
            { initialValue: mdl.factoryId, rules: [{ required: true, message: '请选择所属厂区'}]}]"
          >
            <a-select-option
              v-for="(item, index) in factorySelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="授权"
      style="top: 80px;"
      :width="360"
      v-model="accredit"
      @ok="handleAccreditOk"
      :confirmLoading="confirmLoading"
    >
      <a-form-item label="过期时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
        <a-date-picker
          v-model="mdl.indate"
          format="YYYY-MM-DD HH:mm:ss"
          :disabledDate="disabledDate"
          :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
      </a-form-item>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { codeList, terminalPage, terminalUpdate, terminalSave, terminalDelete, terminalAccredit } from '@/api/sys'
import { factoryList } from '@/api/basic'
import moment from 'moment'
import { formatDate } from '@/utils/date'

export default {
  name: 'Terminal',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      accredit: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '终端名称',
          dataIndex: 'name'
        },
        {
          title: '终端编号',
          dataIndex: 'code'
        },
        {
          title: '机器码',
          dataIndex: 'machineCode'
        },
        {
          title: '所属厂区',
          dataIndex: 'factoryName'
        },
        {
          title: '终端类型',
          dataIndex: 'typeName'
        },
        {
          title: '审核状态',
          dataIndex: 'accreditStateName'
        },
        {
          title: '到期时间',
          dataIndex: 'indate',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return terminalPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],
      // 所属菜单下拉
      typeSelect: null,
      // 厂区下拉
      factorySelect: null,
      // 审核状态下拉
      accreditSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    },
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_terminal_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
      new Promise(resolve => {
        const data = factoryList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.factorySelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_terminal_accredit_state' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.accreditSelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            terminalUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            terminalSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleAccredit(record) {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.accredit = true
    },
    handleAccreditOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          terminalAccredit(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              this.confirmLoading = false
              this.accredit = false
            })
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return terminalDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
